var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baby_manage_tabs"},[(_vm.type === 'goodsLogistics')?_c('goods-logistics-setup',{on:{"tabschange":_vm.tabschange}}):_vm._e(),_vm._v(" "),(_vm.type === 'generalLogistics')?_c('general-logistics-setup',{on:{"tabschange":_vm.tabschange}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a91b4ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/goods-management/default-delivery-logistics/default-delivery-logistics.vue
// module id = null
// module chunks = 